export default "__VITE_ASSET__iFQl1Bn1__"